var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25852 4.87608L2.16795 2.78124C1.93704 2.54985 1.55941 2.55309 1.32451 2.78847L0.473852 3.64087C0.238949 3.87625 0.235719 4.25464 0.466636 4.48603L3.81154 7.83778C4.04246 8.06917 4.42008 8.06593 4.65499 7.83055L10.6096 1.86377C10.8445 1.62839 10.8477 1.25 10.6168 1.01861L9.78058 0.18067C9.54967 -0.0507195 9.17204 -0.0474822 8.93714 0.187901L4.25852 4.87608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTick);
export default __webpack_public_path__ + "static/media/right_tick.4c25149e875e8d4eb3dcb470afc389d1.svg";
export { ForwardRef as ReactComponent };